// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"xi","flipped":"yi","mainContentCtaDefault":"zi","disabled":"Ai","mainContentCtaWhite":"Bi"};